import { Avatar, Flex, Space, Typography } from 'antd';

const { Text } = Typography;

interface Props {
  avatarUrl?: string;
  text: string;
  subText?: string;
}
const AvatarText = ({ subText, text, avatarUrl }: Props) => {
  return (
    <Flex align='center' gap={'.5rem'} data-testid='avatar-text-container'>
      <Avatar
        data-testid='avatar-image'
        size={30}
        src={avatarUrl ?? 'https://joeschmoe.io/api/v1/random'}
      />
      <Flex vertical className='mt-1' data-testid='avatar-text-content'>
        <Text
          data-testid='avatar-main-text'
          className=' font-normal text-sm text-center leading-[18.6px] text-customTunaPrimary'
        >
          {text}
        </Text>
        {subText && (
          <Text
            data-testid='avatar-sub-text'
            className=' font-normal text-[10px] leading-[18px] text-customGrayShade5'
          >
            {subText}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};

export default AvatarText;
